import {Dimensions, StyleSheet} from 'react-native';
import {colorPalette} from '../../theme';

const totalWidth = Dimensions.get('window').width;

export default StyleSheet.create({
  areaContainer: {
    backgroundColor: colorPalette.whiteGrey0,
    width: totalWidth,
    alignItems: 'center',
    flex: 1,
  },
  scrollView: {
    flex: 1,
    alignSelf: 'stretch',
  },
  scrollViewContent: {
    flexGrow: 1,
    alignItems: 'center',
  },
});
